var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52098 0.487757C8.82817 0.803135 9.00008 1.226 9.00008 1.66626C9.00008 2.10652 8.82817 2.52938 8.52098 2.84476L3.95098 7.49976L8.52098 12.1548C8.82817 12.4701 9.00008 12.893 9.00008 13.3333C9.00008 13.7735 8.82817 14.1964 8.52098 14.5118C8.3705 14.6663 8.19059 14.7891 7.99188 14.8729C7.79316 14.9568 7.57966 15 7.36398 15C7.14829 15 6.93479 14.9568 6.73608 14.8729C6.53736 14.7891 6.35746 14.6663 6.20698 14.5118L0.478978 8.67876C0.171785 8.36338 -0.00012207 7.94052 -0.00012207 7.50026C-0.00012207 7.06 0.171785 6.63713 0.478978 6.32176L6.20698 0.487757C6.35746 0.333239 6.53736 0.210428 6.73608 0.126571C6.93479 0.0427147 7.14829 -0.000488281 7.36398 -0.000488281C7.57966 -0.000488281 7.79316 0.0427147 7.99188 0.126571C8.19059 0.210428 8.3705 0.333239 8.52098 0.487757Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlueIcon);
export default __webpack_public_path__ + "static/media/back-blue-icon.a541b9f3ff258311b9401b288e5ae1fc.svg";
export { ForwardRef as ReactComponent };